// @flow
import { connect } from 'react-redux'
import GroupedObjectParametersSelect from './GroupedObjectParametersSelect'
import type { Store } from '../../redux/ducks'
import _ from 'lodash'
import { patch } from '../AudienceEditContainer'
import type { GroupedObjectParameters, VkGroup } from '../types'
import * as segmentationReducer from '../../redux/ducks/segmentation/reducers'

type OwnProps = {|
  selectClassName: string,
  buttonClassName: string,
  blockInputName: string,
  allowAdding: boolean,
  onLoad: (Array<VkGroup>) => void,
  onChange: (Array<VkGroup>) => void
|}

const t = {
  title: 'Сообщества ВКонтакте',
  hint:
    'Вы можете показывать рекламу по участникам выбранных сообществ ВКонтакте. Чтобы выбрать сообщества - начните вводить их название. Если вы выбрали сообщества ВКонтакте для показа рекламы, то мы запустим рекламу только в сетях ВКонтакте и MyTarget'
}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const audienceState = state.audienceEdit

  return {
    ...ownProps,
    title: t.title,
    hint: t.hint,
    groups: audienceState.includedGroups,
    loadedGroups: audienceState.loadedIncludedGroups,
    errors: audienceState.includedGroupsErrors
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onGroupAdd: () => {
      dispatch(segmentationReducer.patch({ segmentByVkGroups: true }))
      patch(dispatch, { useVkGroupNames: true })
    },
    onGroupRemove: (includedGroups: Array<GroupedObjectParameters>) => {
      patch(dispatch, { useVkGroupNames: includedGroups.length > 1 })
    }
  }
}

const IncludedVkGroupsSelectContainer = connect<Object, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(GroupedObjectParametersSelect)

export default IncludedVkGroupsSelectContainer
